// ** Initial State
const initialState = {
    data: [],
    total: 1,
  }
  
  const UserReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_USER_LIST':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
        }
      default:
        return state
    }
  }
  
  export default UserReducer;
  